import { BufferGeometry, Group, Mesh } from 'three'

function concatGroup(node: Group, visible: boolean) {
  const { name, uuid, children, userData, ...rest } = node

  return (
    <group
      key={uuid}
      {...rest}
      castShadow={false}
      receiveShadow={false}
      position={[0, 0, 0]}
    >
      {node.children.length > 0 &&
        node.children.map((node) => {
          if (node instanceof Group) {
            return concatGroup(node, visible)
          }
          if (node instanceof Mesh) {
            return concatMesh(node, visible)
          }
        })}
    </group>
  )
}

function concatMesh(node: Mesh, visible) {
  const { name, uuid, children, userData, ...rest } = node
  
  // Validar que la geometría no tenga NaN en las posiciones
  if (node.geometry && node.geometry instanceof BufferGeometry) {
    try {
      const positionAttribute = node.geometry.getAttribute('position')
      if (positionAttribute) {
        const positions = positionAttribute.array
        let hasNaN = false
        let hasInfinity = false
        
        // Verificar solo los primeros valores para rendimiento (muestra representativa)
        const checkCount = Math.min(positions.length, 100)
        for (let i = 0; i < checkCount; i++) {
          const value = positions[i]
          if (isNaN(value)) {
            hasNaN = true
            break
          }
          if (!isFinite(value)) {
            hasInfinity = true
            break
          }
        }
        
        if (hasNaN || hasInfinity) {
          console.warn(
            `Warning: Geometría ${name || uuid} tiene valores ${hasNaN ? 'NaN' : 'Infinity'} en posiciones, omitiendo...`,
          )
          return null
        }
        
        // Intentar calcular el bounding sphere para detectar problemas adicionales
        try {
          node.geometry.computeBoundingSphere()
        } catch (error) {
          console.warn(
            `Warning: No se puede calcular bounding sphere para geometría ${name || uuid}, omitiendo...`,
            error,
          )
          return null
        }
      }
    } catch (error) {
      console.warn(`Warning: Error al validar geometría ${name || uuid}, omitiendo...`, error)
      return null
    }
  }
  
  return (
    <mesh
      key={uuid}
      {...rest}
      visible={visible}
      castShadow={false}
      receiveShadow={false}
      position={[0, 0, 0]}
    />
  )
}

export function generateSceneLight(light: Node & { children: Node[] }, visible: boolean = true) {
  if (!light || !light.children) return null
  return light.children.map((node: Node) => {
    if (node instanceof Group) {
      return concatGroup(node, visible)
    } else if (node instanceof Mesh) {
      return concatMesh(node, visible)
    }
  })
}
